"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aiModelEngines = exports.deepseekAiEngines = exports.claudeAiEngines = exports.openAiEngines = exports.aiModelTypes = exports.DEEPSEEK_AI = exports.CLAUDE_AI = exports.OPEN_AI = void 0;
exports.OPEN_AI = "OPEN_AI";
exports.CLAUDE_AI = "CLAUDE_AI";
exports.DEEPSEEK_AI = "DEEPSEEK_AI";
exports.aiModelTypes = [exports.OPEN_AI, exports.CLAUDE_AI, exports.DEEPSEEK_AI];
exports.openAiEngines = {
  // GPT_4_VISION: "gpt-4-vision-preview",
  GPT_4_TURBO_2024_04_09: "gpt-4-turbo-2024-04-09",
  GPT_4O_2024_05_13: "gpt-4o-2024-08-06"
};
exports.claudeAiEngines = {
  // CLAUDE_3_SONNET: "claude-3-sonnet-20240229",
  CLAUDE_3_OPUS: "claude-3-opus-20240229",
  CLAUDE_3_HAIKU: "claude-3-haiku-20240307",
  CLAUDE_3_5_SONNET_2024_06_20: "claude-3-5-sonnet-20240620",
  CLAUDE_3_5_SONNET_2024_10_22: "claude-3-5-sonnet-20241022",
  CLAUDE_3_5_SONNET_LATEST: "claude-3-5-sonnet-latest"
};
exports.deepseekAiEngines = {
  DEEP_SEEK_V3: "DeepSeek-V3",
  DEEP_SEEK_R1: "DeepSeek-R1"
};
exports.aiModelEngines = [
// { label: openAiEngines.GPT_4_VISION, value: openAiEngines.GPT_4_VISION, modelType: OPEN_AI },
{
  label: exports.openAiEngines.GPT_4_TURBO_2024_04_09,
  value: exports.openAiEngines.GPT_4_TURBO_2024_04_09,
  modelType: exports.OPEN_AI
}, {
  label: exports.openAiEngines.GPT_4O_2024_05_13,
  value: exports.openAiEngines.GPT_4O_2024_05_13,
  modelType: exports.OPEN_AI
},
// { label: claudeAiEngines.CLAUDE_3_SONNET, value: claudeAiEngines.CLAUDE_3_SONNET, modelType: CLAUDE_AI },
{
  label: exports.claudeAiEngines.CLAUDE_3_OPUS,
  value: exports.claudeAiEngines.CLAUDE_3_OPUS,
  modelType: exports.CLAUDE_AI
}, {
  label: exports.claudeAiEngines.CLAUDE_3_HAIKU,
  value: exports.claudeAiEngines.CLAUDE_3_HAIKU,
  modelType: exports.CLAUDE_AI
}, {
  label: exports.claudeAiEngines.CLAUDE_3_5_SONNET_2024_06_20,
  value: exports.claudeAiEngines.CLAUDE_3_5_SONNET_2024_06_20,
  modelType: exports.CLAUDE_AI
}, {
  label: exports.claudeAiEngines.CLAUDE_3_5_SONNET_2024_10_22,
  value: exports.claudeAiEngines.CLAUDE_3_5_SONNET_2024_10_22,
  modelType: exports.CLAUDE_AI
}, {
  label: exports.claudeAiEngines.CLAUDE_3_5_SONNET_LATEST,
  value: exports.claudeAiEngines.CLAUDE_3_5_SONNET_LATEST,
  modelType: exports.CLAUDE_AI
}, {
  label: exports.deepseekAiEngines.DEEP_SEEK_V3,
  value: exports.deepseekAiEngines.DEEP_SEEK_V3,
  modelType: exports.DEEPSEEK_AI
}, {
  label: exports.deepseekAiEngines.DEEP_SEEK_R1,
  value: exports.deepseekAiEngines.DEEP_SEEK_R1,
  modelType: exports.DEEPSEEK_AI
}];